export const ForceUpdateModal = () => null;
